import React from "react";
import PropTypes from "prop-types";

function EmailWidget(props) {
  const { TextWidget } = props.registry.widgets;
  return <TextWidget type="email" {...props} />;
}

if (process.env.NODE_ENV !== "production") {
  EmailWidget.propTypes = {
    value: PropTypes.string,
  };
}

export default EmailWidget;
